module.exports = __webpack_public_path__ + "github.png?438c17272c5f0e9f4a6da34d3e4bc5bd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/github.png
// module id = 4
// module chunks = 0